import type { App } from "vue";
import { createI18n } from "vue-i18n";
import { useLocaleStoreWithOut } from "@/store/modules/locale";
import type { I18n, I18nOptions } from "vue-i18n";
import { setHtmlPageLang } from "./helper";
import zh_CN from "@/locales/zh_CN.json";
import en_US from "@/locales/en_US.json";
import es_ES from "@/locales/es_ES.json";

export let i18n: ReturnType<typeof createI18n>;

// 语言包映射
const localeModules = {
  zh_CN: zh_CN,
  en_US: en_US,
  es_ES: es_ES,
};

const createI18nOptions = (): I18nOptions => {
  const localeStore = useLocaleStoreWithOut();
  const localeMap = localeStore.getLocaleMap;
  const storedLang = localeStore.getCurrentLocale.lang;
  const lang = localeMap.find((item) => item.lang === storedLang)?.lang || "en_US";

  // 使用静态导入的语言包
  const message = localeModules[lang] || localeModules["en_US"];

  setHtmlPageLang(lang);

  localeStore.setCurrentLocale({
    lang,
    // elLocale: elLocal
  });

  return {
    legacy: false,
    locale: lang,
    fallbackLocale: lang,
    messages: {
      [lang]: message,
    },
    availableLocales: localeMap.map((v) => v.lang),
    sync: true,
    silentTranslationWarn: true,
    missingWarn: false,
    silentFallbackWarn: true,
  };
};

export const setupI18n = (app: App<Element>) => {
  const options = createI18nOptions();
  i18n = createI18n(options) as I18n;
  app.use(i18n);
};
